<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
    
    <!-- Snackbar global para notificaciones -->
    <v-snackbar
      v-model="notification.show"
      :color="notification.color"
      :timeout="notification.timeout"
      location="top right"
    >
      {{ notification.message }}
      <template #actions>
        <v-btn
          variant="text"
          @click="notification.show = false"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useNotificationStore } from '@/stores/notification';

const notificationStore = useNotificationStore();

const notification = computed(() => ({
  show: notificationStore.show,
  message: notificationStore.message,
  color: notificationStore.color,
  timeout: notificationStore.timeout,
}));
</script>

<style lang="scss">
html {
  overflow-y: auto !important;
}
</style>
